import React, {useState} from "react";
import {LoadingContent} from "../LoadingContent";
import useApiCall, {makeApiCall} from "../../hooks/CancellableApiCall";
import {DiscordChannelConfigurationPanelResponse} from "../../data/discord/DiscordChannelConfigurationPanelResponse";
import {Grid, InputLabel, MenuItem, Select} from "@mui/material";
import {DiscordChannelData} from "../../data/discord/DiscordChannelData";
import {DiscordChannelConfigurationResponse} from "../../data/discord/DiscordChannelConfigurationResponse";
import {divisionIdentifierToDisplayName} from "../../utils";

interface DiscordRoePanelContentProps {
    data: DiscordChannelConfigurationPanelResponse
}

interface DiscordChannelConfigValueProps {
    type: string
    channel?: DiscordChannelConfigurationResponse
    allChannels: DiscordChannelData[]
}

const DiscordChannelConfigValue = (props: DiscordChannelConfigValueProps) => {
    const [channel, setChannel] = useState(props.channel?.channelId)

    return <Grid item>
        <InputLabel id="channel-select-label">{divisionIdentifierToDisplayName(props.type)}</InputLabel>
        <Select size="small" sx={{width: 300}} id="channel-select" value={channel} variant="standard"
                onChange={(event) => {
                    setChannel(event.target.value)
                    makeApiCall({
                        url: `/api/discord/channel-configurations/modify/${props.type.toUpperCase()}?channel_id=${event.target.value}`,
                        method: "PATCH",
                        onLoadedCallback: _ => {},
                        onError: () => {}
                    })
                }}>
            {props.allChannels.map(channel => {
                return <MenuItem key={channel.channelId} value={channel.channelId}>{channel.displayName}</MenuItem>
            })}
        </Select>
    </Grid>
}

const DiscordChannelConfigPanelContent = (props: DiscordRoePanelContentProps) => {
    return <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        {props.data.configurationTypes && props.data.configurationTypes.map(configType => {
            return <DiscordChannelConfigValue
                key={configType}
                allChannels={props.data.channels}
                type={configType}
                channel={props.data.currentConfigurations.find(S => {return S.type === configType})}
            />
        })}
    </Grid>
}

export const DiscordChannelConfigPanel = () => {
    const channelConfigData = useApiCall<DiscordChannelConfigurationPanelResponse>({
        url: "/api/discord/channel-configurations"
    })

    return (<LoadingContent showLoadingSkeleton={true} isLoading={channelConfigData.isLoading || !channelConfigData.data}>
        <DiscordChannelConfigPanelContent data={channelConfigData.data!!} />
    </LoadingContent>)
}